import React from "react";
import { DefaultButton, Stack, Text } from "@fluentui/react";
import { AdminAction } from "./AdminStore";

interface ActionDetailProps {
  action: AdminAction;
  onBack: () => void;
}

function DetailRow(props: { label: string; value: string }) {
  return (
    <Stack horizontal tokens={{ childrenGap: 12 }} styles={{ root: { marginBottom: 8 } }}>
      <Text styles={{ root: { width: 160, color: "#666" } }}>{props.label}</Text>
      <Text styles={{ root: { flex: 1, wordBreak: "break-word" } }}>{props.value}</Text>
    </Stack>
  );
}

function formatRaw(raw: string): string {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

export const ActionDetail: React.FunctionComponent<ActionDetailProps> = ({ action, onBack }) => {
  return (
    <Stack tokens={{ childrenGap: 16 }} styles={{ root: { maxWidth: 720, padding: 24 } }}>
      <DefaultButton text="Back to list" onClick={onBack} styles={{ root: { width: 140 } }} />
      <Text variant="xLarge">Action Detail</Text>
      <DetailRow label="Date" value={new Date(action.createdAt).toLocaleString()} />
      <DetailRow label="Lead email" value={action.leadEmail} />
      <DetailRow label="Lead name" value={`${action.leadFirstName} ${action.leadLastName}`} />
      <DetailRow label="Company" value={action.leadCompany} />
      <DetailRow label="Action code" value={action.actionCode} />
      <DetailRow label="Offer title" value={action.offerTitle} />
      <DetailRow label="Description" value={action.description} />
      <DetailRow label="Lead source" value={action.leadSource} />
      <Stack tokens={{ childrenGap: 8 }}>
        <Text styles={{ root: { color: "#666" } }}>Raw payload</Text>
        <Text
          styles={{
            root: {
              fontFamily: "Consolas, monospace",
              fontSize: 12,
              whiteSpace: "pre-wrap",
              wordBreak: "break-all",
              background: "#f5f5f5",
              padding: 12,
              borderRadius: 4,
            },
          }}
        >
          {formatRaw(action.raw)}
        </Text>
      </Stack>
    </Stack>
  );
};
